import { createFileRoute } from '@tanstack/react-router'
import { HomeViewModel } from '@/components/home/home.view-model'
import { SITE_DEFAULT_DESCRIPTION, SITE_DEFAULT_TITLE } from '@/constants/site'
import { buildPageMeta } from '@/lib/seo/build-page-meta'

export const Route = createFileRoute('/')({
  head: () =>
    buildPageMeta({
      title: SITE_DEFAULT_TITLE,
      description: SITE_DEFAULT_DESCRIPTION,
      path: '/',
    }),
  component: HomeViewModel,
})
